import { render, staticRenderFns } from "./BillArea.vue?vue&type=template&id=f306a978&"
import script from "./BillArea.vue?vue&type=script&lang=js&"
export * from "./BillArea.vue?vue&type=script&lang=js&"
import style0 from "./BillArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports